import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_BANK, DELETE_BANK, GET_BANK, UPDATE_BANK, GET_All_BANK, GET_ONE_BANK, MULTI_DELETE_BANK } from '../types';

export const getBank = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/bank-branch/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_BANK,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error("Failed to get Color. Please try again.", err);
   }
};

export const addBank = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/bank-branch/add', formData);
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 1) {
         dispatch({ type: ADD_BANK, payload: res.data.data });
         setTimeout(() => {
            toast.success('Bank added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateBank = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/bank-branch/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_BANK, payload: res.data.data });

         setTimeout(() => {
            toast.success('Bank updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// Delete Bank
export const deleteBank = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/bank-branch/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_BANK, payload: { id } });
         setTimeout(() => {
            toast.success('Bank deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Bank. Please try again.");
   }
};

export const multiDeleteBank = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/bank-branch/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_BANK, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getAllBank = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/bank/all`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_All_BANK,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      // console.error("Failed to get Color. Please try again.", err);
   }
};

export const getSingleBankBranch = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/bank-branch/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_BANK, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
